import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { Typography } from 'Components/Typography';

const StyledTypography = styled(Typography)`
  text-transform: uppercase;
  color: ${theme.colors.neutral[800]};

  span {
    color: ${theme.colors.neutral[900]};
    text-transform: none;
  }
`;

type IngredientInfosProps = {
  children: React.ReactNode;
  dash?: boolean;
  variant?: string;
};

export const IngredientInfos = ({
  dash = false,
  children,
  variant = 'mono3',
}: IngredientInfosProps) => (
  // @ts-expect-error - variant type not fined grained enough for Typography
  <StyledTypography variant={variant}>
    {dash && <> &nbsp;- </>}
    {children}
  </StyledTypography>
);
